import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { MaterialBottomSheetLink } from '../../../business/material-bottom-sheet/material-bottom-sheet-link';
import { MaterialDisabledActionDirective } from '../../../directives/material-disabled-action.directive';

@Component({
    selector: 'ecm-mat-bottom-sheet-link-items',
    templateUrl: 'material-bottom-sheet-link-items.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MaterialDisabledActionDirective],
})
export class MaterialBottomSheetLinkItemsComponent {
    public items = input<MaterialBottomSheetLink[]>([]);
    public clickLink = output<MaterialBottomSheetLink>();
}
